export const paperTheme = {
    styleOverrides: {
        root: ({ theme }) => ({
            borderRadius: theme.shape.borderRadius,
            boxShadow: 'unset',
            '&.MuiPopover-paper,&.MuiAutocomplete-paper,&.MuiPickersPopper-paper': {
                boxShadow: theme.shape.popoverShadow(theme),
            },
        }),
    },
};
